import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { BiData, RedirectToLoginBiEvent } from '@wix/da-bi/pkg/events';
import s from './EmptyWatchedGroups.scss';

export interface Props {}

const EmptyWatchedGroups: React.FC<Props> = props => {
  const { t } = useTranslation();
  const { isLoggedIn } = useContext(SessionContext);

  if (isLoggedIn) {
    return (
      <div className={s['groups-empty']}>
        <div className={s['watch-groups']}>
          {t('networkBar.groups.empty.header')}
        </div>
        <div className={s['but-why']}>{t('networkBar.groups.empty.text')}</div>
      </div>
    );
  }

  return (
    <div className={classnames(s['groups-empty'], s['anon'])}>
      <div className={s['but-why']}>
        {t('networkBar.groups.empty.anon.text')}
      </div>
      <BrandedButton
        variant="brand-green"
        size="small"
        className={s['signup']}
        href={Url.joinLink()}
        biData={BiData<RedirectToLoginBiEvent>({
          evid: 240,
          referral_info: ReferralType.ANON_NETWORKBAR,
        })}
      >
        {t('networkBar.groups.empty.anon.join')}
      </BrandedButton>
    </div>
  );
};
EmptyWatchedGroups.displayName = 'EmptyWatchedGroups';

export default EmptyWatchedGroups;
